import { MinimalButton, MinimalFormSection } from '@ovasabi/ui-minimal'
import { ALLERGEN_CATEGORIES } from './allergens'

const choices = [{ slug: 'none', label: 'None of these allergens' }, ...ALLERGEN_CATEGORIES]

export const DishAllergens = ({ value, onChange }: {
  value: ReadonlySet<string>
  onChange: (next: ReadonlySet<string>) => void
}) => {
  const toggle = (slug: string) => {
    if (slug === 'none') { onChange(new Set(value.has('none') ? [] : ['none'])); return }
    const next = new Set(value)
    next.delete('none')
    if (next.has(slug)) next.delete(slug)
    else next.add(slug)
    onChange(next)
  }
  return <MinimalFormSection title="Allergens" description="Select every allergen in this dish, or confirm that none apply.">
    <div role="group" aria-label="Dish allergens" style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
      {choices.map((choice) => <MinimalButton key={choice.slug} type="button" size="sm" variant={value.has(choice.slug) ? 'primary' : 'secondary'} aria-pressed={value.has(choice.slug)} onClick={() => toggle(choice.slug)}>{choice.label}</MinimalButton>)}
    </div>
  </MinimalFormSection>
}
